import { render, staticRenderFns } from "./GravarUsuarioDialog.vue?vue&type=template&id=4636fb1b&"
import script from "./GravarUsuarioDialog.vue?vue&type=script&lang=js&"
export * from "./GravarUsuarioDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports